module.exports = __webpack_public_path__ + "src/app/assets/images/jug-milano.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/jug-milano.png
// module id = 625
// module chunks = 0